// ======================================================================
// File Name       : group
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { downloadFile } from '../../utils/index';
import { SELECT_TARGET_DATA, STRUCTURE_LEVEL } from '../../constants';
import { DATA_LIMIT_FLAG } from '../../constants/GroupConstants';

export function postGroupGetStructure(data, isGetAll) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
    targetGroupSecernId: null,
    recursiveType: STRUCTURE_LEVEL.ALL,
    dataLimitFlag: DATA_LIMIT_FLAG.LIMIT,
  };
  if (isGetAll) {
    delete PARAM_DEFAULT.dataLimitFlag;
  }
  return commonCallApi({
    path: 'group/GetStructure',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

export function postGroupEdit(editType, groupInfo) {
  return commonCallApi({
    path: 'group/Edit',
    data: { editType, groupInfo },
  });
}

export function postUserGroupRelationGetList(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.DATA,
  };

  return commonCallApi({
    path: 'userGroupRelation/GetList',
    data: { ...PARAM_DEFAULT, ...data },
  });
}

export function postUserGroupRelationEdit(editType, groupSecernId, userList) {
  return commonCallApi({
    path: 'groupUserRelation/Edit',
    data: { editType, groupInfo: { groupSecernId, userList } },
  });
}

export function exportCSV(data) {
  const PARAM_DEFAULT = {
    selectTargetData: SELECT_TARGET_DATA.CSV,
    targetGroupSecernId: null,
    recursiveType: STRUCTURE_LEVEL.ALL,
    dataLimitFlag: DATA_LIMIT_FLAG.LIMIT,
  };
  return commonCallApi({
    path: 'group/GetStructure',
    data: { ...PARAM_DEFAULT, ...data },
  }).then((resdata) => {
    const url = resdata && resdata.csvfileUrl ? resdata.csvfileUrl : null;
    downloadFile(url);
  });
}
